import { render } from "./ConfirmArchivage.vue?vue&type=template&id=0ebba546"
import script from "./ConfirmArchivage.vue?vue&type=script&lang=js"
export * from "./ConfirmArchivage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__